import { WebStorageStateStore } from 'oidc-client-ts';

import {
  environment,
  sbx,
  uat,
  prod
} from './solaris-lens-common-lib/src/constants/endpoints';

const oidcEnv = [sbx, uat, prod];
export const isOidcClient = oidcEnv.includes(environment);

const currentUri = (
  window.location.protocol +
  '//' +
  window.location.host
).replace(/\/$/, '');

const clientId = '7ndnv0l2g65og32441mn1n90l9';
const tenantId = 'b05ca04b-5c87-4451-b694-e7b04e21fffc';
const authority = 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_AF3n2FEWw/';
const cognitoDomain = 'https://us-east-1af3n2feww.auth.us-east-1.amazoncognito.com/';

const response_type = 'code';
const redirect_uri = `${currentUri}/login`;
const silent_redirect_uri = `${currentUri}/logout`;
const post_logout_redirect_uri = `${currentUri}/logout`;
const scope = 'email openid profile';

const cognitoLogoutRedirect = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(currentUri)}`;

const microsoftSignOutUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURIComponent(cognitoLogoutRedirect)}`;

export const signOutRedirect = (idToken: any, email: any) => {
  window.location.href = `${microsoftSignOutUrl}&login_hint=${email}&id_token_hint=${idToken}`;
};

export const startPresignupRecoveryLogout = (
  idToken?: string,
  email?: string
) => {
  let url = microsoftSignOutUrl;

  if (idToken && email) {
    url += `&login_hint=${encodeURIComponent(email)}&id_token_hint=${encodeURIComponent(idToken)}`;
  }

  window.location.href = url;
};

const onSigninCallback = () => {
  const params = new URLSearchParams(window.location.search);

  if (params.get('error')) {
    return;
  }

  window.history.replaceState({}, document.title, window.location.pathname);
};

export const oidcConfig = {
  authority,
  client_id: clientId,
  redirect_uri,
  response_type,
  scope,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  silent_redirect_uri,
  post_logout_redirect_uri,
  automaticSilentRenew: true,
  onSigninCallback
};

export const refreshTokenConfig = (auth: any) => {
  if (!auth?.tokenPayload?.exp) {
    return {
      expiresInSec: 0,
      refreshTime: 0,
      expDate: null,
      timeUntilExpiration: true,
      needRefresh: false
    };
  }

  const buffer = 60;
  const now = Math.floor(Date.now() / 1000);
  const exp = auth.tokenPayload.exp;
  const iat = auth.tokenPayload.iat;

  const expiresInSec = exp - now;
  const refreshTime = Math.max(expiresInSec - buffer, 0) * 1000;

  const expDate = new Date(exp * 1000);
  const issuedAtDate = new Date(iat * 1000);

  const needRefresh = now >= exp - buffer;

  return {
    expDate,
    issuedAtDate,
    expiresInSec,
    refreshTime,
    timeUntilExpiration: expiresInSec <= 0,
    needRefresh
  };
};
